<app-modal [active]="batchStarted" (modalClosed)="batchStarted=false">
    <app-batch-download></app-batch-download>
</app-modal>

<div style="background-color: #f7f7f7; padding: 2rem">
    <div class="columns" style="margin-bottom: 2rem">
        <div class="column is-1"></div>
        <div class="column" style="color: #35566E; font-size: 23px">Meine Bestellungen</div>
        <div class="column is-4">
        </div>
        <div class="column search">
            <div class="columns">
                <div class="column">
           <span><input class="input" [(ngModel)]="searchText" type="text" placeholder="Suche"
                        (keyup)="setFoundDocuments()"
                        style="width: 150px; border-bottom: none !important;background-color: #ffffff">
           </span>
                </div>
                <div class="column">
                    <span style="float: right; padding: 8px"></span>
                </div>
            </div>
        </div>
        <div class="column is-1"></div>
    </div>

    <div *ngIf="order && property" class="columns">
        <div class="column is-1"></div>
        <div class="column" style="border-radius: 15px; border-top: none; height: 100%; background-color: #ffffff ">
            <div class="columns"
                 style="background-color: #336E99; border: 1px solid; border-bottom: none;  border-radius: 10px; color: white">
                <div class="column is-narrow pl-5 is-flex is-justify-content-center is-align-items-center">
                    <a class="is-clickable color-white" (click)="cancelFilesAndFolderRequests()" routerLink="/order_details/{{order.orderid}}" [state]="order">
                        <fa-icon [icon]="faArrowLeft"></fa-icon>
                    </a>
                    <span class="ml-5" style="vertical-align: middle">Auftrag {{order.orderid}}</span>
                </div>
            </div>
            <div class="columns m-0 mt-4">
                <div class="column is-2 does-not-wrap"><span style="font-size: 13px">
                    Bestelldatum: {{order.entrydate | date:'dd.MM.yyyy'}} </span>
                </div>
                <div class="column is-8">
                    <h6 class="title is-4 color-darkblue is-bold has-text-centered">
                        Objektfortschritt
                    </h6>
                    <div class="mb-5 color-darkblue has-text-centered">
                        {{property.street + (property.house_number ? ' ' + property.house_number : '')}}, {{property.zip}} {{property.town}}
                    </div>

                    <div class="is-flex is-justify-content-center">
                        <circle-progress subtitle="{{progress() |number: '1.0-2':'de'}}%"
                                         [percent]="progress()"
                                         [backgroundStrokeWidth]=0
                                         [backgroundPadding]=5
                                         [radius]=85
                                         [space]=-2
                                         [outerStrokeWidth]=3
                                         [outerStrokeColor]="'#73B1D6'"
                                         [outerStrokeLinecap]="'butt'"
                                         [innerStrokeColor]="'#f7f7f7'"
                                         [innerStrokeWidth]=3
                                         [subtitleColor]="'#35566E'"
                                         [titleFontWeight]="'900'"
                                         [subtitleFontSize]="'26'"
                                         [animateTitle]=false
                                         [animationDuration]=1000
                                         [showTitle]=false
                                         [showUnits]=false
                                         [showBackground]=false
                                         [clockwise]=true
                                         [responsive]=false
                                         [startFromZero]=false
                                         [lazy]=true
                        ></circle-progress>
                    </div>

                    <div class="download has-text-centered mt-4 max-w-250 is-flex is-justify-content-space-evenly is-align-items-center"
                         (click)="hasDownloadPermissions() ? downloadByProperty(property) : $event.stopPropagation()">
                      <p>Alle Dokumente herunterladen</p>
                      <div class="is-flex is-justify-content-center is-align-items-center h-0">
                        <img class="download-icon" alt="Download Icon" src="assets/images/download_icon/download_icon_light.svg">
                      </div>
                    </div>
                </div>
                <div class="column is-2 is-flex is-flex-direction-column">
                  <div class="card has-text-centered" style="padding: 1rem; border-radius: 20px; background-color: #f7f7f7">
                    <span class="is-size-6">Eingetroffene Auskünfte</span> <br>
                    <span class="color-darkblue is-size-3">{{(property.documents | filterPipe: 'received' : true)?.length }} / {{property.documents.length}}</span>
                  </div>
                  <div class="margin-top-auto is-flex is-justify-content-end pr-225-rem">
                    <img appCustomTooltip [tooltipTemplate]="iconTooltip" alt="Info Icon" src="assets/images/InfoIcon/info_icon.svg">
                  </div>
                </div>
            </div>


            <ng-container *ngIf="!searchText else showFoundDocuments">
                <div class="columns">
                    <div class="column" style="padding: 1rem; height: 100%">
                        <div class="has-text-centered mb-5">
                            <div class="title is-4 is-bold has-text-centered mb-1 color-darkblue">
                                Dokumente
                            </div>
                        </div>

                        <div class="columns is-justify-content-center">
                            <div class="column is-12">
                                <div class="card"
                                     style="padding: 2rem; background-color: #f7f7f7 ; border-radius: 20px; padding-bottom: 0; padding-right: 0.5rem">
                                    <div *ngIf="!property "></div>
                                    <ng-container *ngFor="let document of property.documents; let index = index">
                                        <div *ngIf="!planungDocumentNames.includes(document.docname)">
                                            <app-document-row data-cy="document_row_{{document.docname}}" #documentRowComponent [document]="document" [order]="order" [property]="property" [customerInteractions]="property.customerInteractions"
                                                              (updateBatchStarted)="updateBatchStarted($event)"></app-document-row>
                                        </div>
                                    </ng-container>

                                    <div *ngIf="planungDocuments.length > 0">
                                        <app-planung-document-row #planungDocumentRowComponent [planungDocuments]="planungDocuments"
                                                                  [property]="property"
                                                                  [customerInteractions]="property.customerInteractions"
                                                                  [order]="order"
                                                                  [batchingPlanungDocumentsObservable]="batchingPlanungDocumentsObservable"
                                                                  (updateBatchStarted)="updateBatchStarted($event)"></app-planung-document-row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!--feedback after a new customer interaction (incl. attached files) was submitted-->
            <app-notification *ngIf="customerInteractionNotification" data-testid="ci-notification"
                              [content]="customerInteractionNotification.content"
                              [error]="customerInteractionNotification.error"
                              [success]="!customerInteractionNotification.error"
                              [display]="true"
                              [timeOut]="customerInteractionNotification.error ? 0 : 5000"
                              (notificationClosed)="customerInteractionNotification = null"></app-notification>

            <div class="columns">
                <div class="column has-text-centered">
                    <p class="is-size-6">Haben Sie eine Frage zu diesem Objekt? Dann klicken Sie
                        <a (click)="showCustomerInteractionModal=true;">hier!</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="column is-1"></div>
    </div>

    <!--Template that is used if the user is searching for a specific Document-->
    <app-modal [active]="showCustomerInteractionModal" (modalClosed)="showCustomerInteractionModal=false" [width]="1200">
        <app-customer-interaction *ngIf="showCustomerInteractionModal" customerInteractionId="new" [property]="property" [insideCard]="true" (closeCiModalAndUpdateProperty)="closeCiModalAndUpdateProperty($event)"></app-customer-interaction>
    </app-modal>

    <ng-template #showFoundDocuments>
        <div *ngIf="order && property" class="columns">
            <div class="column is-1"></div>
            <div class="column" style="border-radius: 15px; border-top: none; height: 100%; background-color: #ffffff ">
                <div class="columns">
                    <div class="column" style="padding: 1rem; height: 100%">
                        <div class="columns">
                            <div class="column is-1"></div>
                            <div class="column">
                                <div id='outer-container' class="card"
                                     style="padding: 2rem; background-color: #f7f7f7 ; border-radius: 20px; padding-bottom: 0rem; padding-right: 0.5rem">
                                    <div *ngIf="!foundDocuments ">
                                        <div class="container mb-5">
                                            <div class="columns card"
                                                 style="padding:0 1rem !important;border-radius: 25px; z-index: 1">
                                                <div class="column">
                                                    <p>Es konnte kein passendes Dokument gefunden werden. Zurück zur <a
                                                            routerLink="/order">Bestellübersicht?</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="document"
                                         *ngFor="let document of property.documents | search: searchText:'documents'; let index = index">
                                      <app-document-row [document]="document" [order]="order" [property]="property" [customerInteractions]="property.customerInteractions"
                                                        (updateBatchStarted)="updateBatchStarted($event)"></app-document-row>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-1"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-1"></div>
        </div>
    </ng-template>
</div>

<ng-template #iconTooltip>
  <div class="card p-5 has-round-border">
    <div class="columns is-justify-content-center" *ngFor="let tooltipIconMapping of tooltipIconArray">
      <div class="column is-flex">
        <img class="tooltip-image" alt="Tooltip Icon" src="{{tooltipIconMapping.image}}">
        <p class="ml-2">{{tooltipIconMapping.key}}</p>
      </div>
    </div>
  </div>
</ng-template>
